(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/services/async-callback.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/services/async-callback.js'); "use strict";


svs.sportsbook.sbtech_api_impl.services.asyncCallback = function () {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  const responses = new Array(callbacks.length);
  let compleatedCallbacks = 0;
  return finishCallback => {
    callbacks.forEach((callback, i) => callback(function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      responses[i] = args;
      if (++compleatedCallbacks === callbacks.length) {
        finishCallback(responses);
      }
    }));
  };
};
 })(window);